import { z } from 'zod';

/**
 * Verfügbarkeitsprüfung für Belegpositionen: pro Artikel wird geprüft, ob die
 * gewünschte Menge aktuell frei verfügbar ist (Bestand − Reservierungen). Fehlt
 * etwas, wird der offene Zulauf aus laufenden Bestellungen gemeldet (Menge +
 * frühester Liefertermin).
 */
export const availabilityCheckRequestSchema = z.object({
  items: z
    .array(z.object({ articleId: z.string().uuid(), quantity: z.number().positive() }))
    .min(1)
    .max(500),
});
export type AvailabilityCheckRequest = z.infer<typeof availabilityCheckRequestSchema>;

/** Offener Zulauf eines Artikels aus laufenden Bestellungen. */
export const incomingSupplySchema = z.object({
  orderedQty: z.number(),
  /** Frühester voraussichtlicher Liefertermin der offenen Bestellungen, ISO oder null. */
  nextExpectedDate: z.string().datetime().nullable(),
  /** Referenz-Bestellung (die mit dem frühesten Termin) für den Absprung. */
  orderId: z.string().uuid(),
  orderNumber: z.string(),
});
export type IncomingSupply = z.infer<typeof incomingSupplySchema>;

/** Offener Zulauf je Artikel — Zeile der Bestandsübersicht (GET /purchase-orders/open-incoming). */
export const openIncomingEntrySchema = incomingSupplySchema.extend({
  articleId: z.string().uuid(),
});
export type OpenIncomingEntry = z.infer<typeof openIncomingEntrySchema>;

export const availabilityLineSchema = z.object({
  articleId: z.string().uuid(),
  articleNumber: z.string(),
  name: z.string(),
  requested: z.number(),
  available: z.number(),
  /** true = gewünschte Menge sofort frei verfügbar. */
  sufficient: z.boolean(),
  /** Fehlmenge (0, wenn ausreichend). */
  shortfall: z.number(),
  /** Zulauf aus Bestellungen (null = keine offene Bestellung für diesen Artikel). */
  incoming: incomingSupplySchema.nullable(),
});
export type AvailabilityLine = z.infer<typeof availabilityLineSchema>;

export const availabilityCheckResponseSchema = z.object({
  allAvailable: z.boolean(),
  lines: z.array(availabilityLineSchema),
});
export type AvailabilityCheckResponse = z.infer<typeof availabilityCheckResponseSchema>;
